import React from 'react';

const ConcertSupportCard = ({
  title = 'Support None Urabikoze Concert',
  subtitle = 'You can also support the concert financially using any of the options below.',
}) => {
  return (
    <div className="bg-white dark:bg-[#111010] border border-gray-200 dark:border-white/10 shadow-sm dark:shadow-black/40 text-gray-900 dark:text-white p-6 sm:p-8 rounded-xl max-w-md w-full mx-auto">
      <h3 className="text-xl sm:text-2xl text-center mb-2 font-glsnecb tracking-wide uppercase">{title}</h3>
      <p className="text-center text-gray-500 dark:text-gray-400 text-sm mb-6">
        {subtitle}
      </p>

      <div className="space-y-4">
        {/* Parked for now — re-enable by uncommenting when this Mobile Money number is current again.
        <div className="border border-gray-200 dark:border-white/10 rounded-lg p-4 bg-gray-50 dark:bg-white/5">
          <p className="text-gray-500 dark:text-gray-400 text-xs uppercase tracking-wider mb-2">Mobile Money</p>
          <p className="text-gray-900 dark:text-white text-lg font-semibold">0787703535</p>
          <p className="text-gray-500 dark:text-gray-400 text-xs mt-1">Names: EM Wave Ltd</p>
        </div>
        */}

        <div className="border border-gray-200 dark:border-white/10 rounded-lg p-4 bg-gray-50 dark:bg-white/5">
          <p className="text-gray-500 dark:text-gray-400 text-xs uppercase tracking-wider mb-2">MoMo Pay Code</p>
          <p className="text-gray-900 dark:text-white text-lg font-semibold">3322</p>
          <p className="text-gray-500 dark:text-gray-400 text-xs mt-1">Names: EM Wave Ltd</p>
        </div>

        <div className="border border-gray-200 dark:border-white/10 rounded-lg p-4 bg-gray-50 dark:bg-white/5">
          <p className="text-gray-500 dark:text-gray-400 text-xs uppercase tracking-wider mb-2">Mobile Money</p>
          <p className="text-gray-900 dark:text-white text-lg font-semibold">+250798445871</p>
          <p className="text-gray-500 dark:text-gray-400 text-xs mt-1">Names: Diane NIYONSENGA</p>
        </div>

        <div className="border border-gray-200 dark:border-white/10 rounded-lg p-4 bg-gray-50 dark:bg-white/5">
          <p className="text-gray-500 dark:text-gray-400 text-xs uppercase tracking-wider mb-2">Bank Transfer (Equity Bank)</p>
          <p className="text-gray-900 dark:text-white text-sm"><span className="text-gray-500 dark:text-gray-400">Account Number:</span> 4012201443261</p>
          <p className="text-gray-900 dark:text-white text-sm"><span className="text-gray-500 dark:text-gray-400">Account Name:</span> EM Wave Ltd</p>
          <p className="text-gray-900 dark:text-white text-sm"><span className="text-gray-500 dark:text-gray-400">Bank:</span> Equity</p>
        </div>
      </div>
    </div>
  );
};

export default ConcertSupportCard;
